import {
    ClientManagerInstanceToken,
    ConfigService,
    CustomInjector,
    DateUtilities,
    TimesheetAndExpensesService,
} from '@evorait/pace-core';
import moment from 'moment';

export default class StartWorkModel {
    public endOfWorkTime: string;
    public endOfWork: moment.Moment;
    public startOfWorkTime: string;
    public startOfWork: moment.Moment;
    public frontId: string;
    public constructor() {
        const injector = CustomInjector.getInjector();

        const timesheetAndExpensesService = injector.get(TimesheetAndExpensesService);
        const configService = injector.get(ConfigService);
        const clientManager = injector.get(ClientManagerInstanceToken);

        this.frontId = configService.getUserFrontId();
        this.startOfWork = moment().startOf('minute');
        this.startOfWorkTime = this.startOfWork.format(clientManager.getTimeFormat());

        const submittedTimesheet = timesheetAndExpensesService.getSubmittedTimesheet();
        this.endOfWork = submittedTimesheet.getEndOfWork();
        if (this.endOfWork.isValid()) {
            this.endOfWorkTime = this.endOfWork.format(clientManager.getTimeFormat());
        }
    }

    public get endOfWorkDate(): string {
        return this.endOfWork.isValid() ? DateUtilities.formatDate(this.endOfWork) : '';
    }

    public get startOfWorkDate(): string {
        return DateUtilities.formatDate(this.startOfWork);
    }
}
